import React from 'react';

import { useFormContext } from 'react-hook-form';
import { observer } from 'mobx-react';

import { MultipleComboBox } from '../../../../../../../../components/form-components';
import { CustomFilterFormValues } from '../../../AddCustomFilterForm.settings';
import { useSchoolsList } from '../../../../../../../../hooks/schools/useSchoolsList';

const AffiliateGroupFilter = observer(() => {
  const { control } = useFormContext<CustomFilterFormValues>();

  const { schoolListOption } = useSchoolsList({
    isRunGlobalSpinner: false,
    isScholastic: true,
  });

  return (
    <MultipleComboBox
      control={control}
      size="small"
      variant="outlined"
      name="filters.PERSONAL_INFO.schoolIds"
      label="Affiliate"
      options={schoolListOption}
      limitTags={3}
    />
  );
});

export { AffiliateGroupFilter };
